import { ROUTE_DASHBOARD, ROUTE_DASHBOARD_BOOKING_PAGE } from '@/constants/routes';
import { useCreateEventTypeMutation, useListEventTypesQuery } from '@/queries/eventTypes.queries';
import eventTypeService from '@/services/eventType.service';
import uuidService from '@/services/uuid.service';
import EventSummary from '@/types/EventSummary';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function useEventList() {
	const { t } = useTranslation();
	const queryListEventTypes = useListEventTypesQuery();
	const history = useHistory();
	const queryCreateEventType = useCreateEventTypeMutation();

	function createEventType() {
		const id = uuidService.v4();
		queryCreateEventType.mutate(
			{ id },
			{
				onSuccess() {
					toast.success(t('Booking page created.') as string);
					history.push(ROUTE_DASHBOARD_BOOKING_PAGE.replace(':id', id));
				},
			}
		);
	}

	function copyLink(service: EventSummary) {
		window.event?.preventDefault();
		navigator.clipboard.writeText(eventTypeService.getIdLink(service.id));
		toast.success(t('Link copied.') as string);
	}

	return {
		status: queryListEventTypes.status,
		props: {
			action: { text: t('Create'), onClick: createEventType },
			back: { text: t('Home'), link: ROUTE_DASHBOARD },
			eventTypes: queryListEventTypes?.data?.eventTypes as Array<EventSummary>,
			history,
			copyLink,
			createEventType: createEventType,
			t,
		},
	};
}
